@use "@design/design-tokens/typography/typography" as *;

.root {
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  box-sizing: border-box;
  padding: 12px 20px;

  &:hover {
    background-color: var(--surface-hover);
  }

  &:focus-visible {
    outline: 2px solid var(--border-focus);
    outline-offset: -2px;
  }

  &.defaultVariant {
    border-radius: 8px;
    background: var(--background-soft);
    padding: 12px;
  }
}

.flexWrapper {
  display: flex;
  gap: 12px;
  min-width: 0;
}

.content {
  width: 100%;
  min-width: 0;
  flex: 1;
}

.headerWrapper {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 8px;
  min-width: 0;
  gap: 32px;
}

.cardTitle {
  @include typography-v2-title-base;
  color: var(--text-default);

  &.defaultVariant {
    @include typography-v2-title-md;
  }
}

.dateLabel {
  @include typography-v2-body-xs;
  color: var(--text-soft);
}

.cardDescription {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1;
}

.description {
  display: flex;
  gap: 8px;
}

.wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-width: 0;
}

.footerWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 4px;
}

.greyDot {
  width: 2px;
  height: 2px;
  border-radius: 50%;
  display: inline-block;
  background-color: var(--icon-soft);
}

.cardType {
  @include typography-v2-title-sm;
  color: var(--text-soft);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  flex: 0 1 auto;
}

.tickerLabel {
  @include typography-v2-body-sm;
  color: var(--text-soft);
  flex-shrink: 0;
}

.marketFooterContent {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;

  .greyDot:last-child {
    display: none;
  }
}

.marketWideIconWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  flex-shrink: 0;
}
